import { InputAdornment, InputBase } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

import "./HeaderSearchInput.scss";

const HeaderSearchInput = ({
  placeholder = "Search",
  type = "text",
  defaultValue = "",
  handleChange,
  clx = "",
  ...rest
}) => {
  const [value, setValue] = useState("");

  const handleChangeValue = (e) => {
    const val = e.target.value;
    setValue(val);
    handleChange(val);
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <InputBase
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={handleChangeValue}
      className={`HeaderSearchInput ${clx} py-0`}
      endAdornment={
        <InputAdornment position="end">
          <SearchIcon className="HeaderSearchInput__search" />
        </InputAdornment>
      }
      {...rest}
    />
  );
};

export default memo(HeaderSearchInput);
